import { CartDescriptionException, CartExceptionType } from '@cargos/sprintpay-models';

export const formNotesErrors = {
    notes: {
        code: 'required',
        message: CartDescriptionException[CartExceptionType.COMPANY_POLICY],
    },
};
